module.exports = __webpack_public_path__ + "img/xiaochengxu1.e415f3e3.svg";